import { useQuery } from '@tanstack/react-query'
import { apiGet } from '../lib/api'
import { useAuth } from './useAuth'

/** Shared query keeps every cog/CTA in sync; polling also covers missed pushes. */
export function useSupportUnread() {
  const { user } = useAuth()
  return useQuery({ queryKey: ['support', 'unread', user?.id],
    queryFn: () => apiGet<{ count: number }>('/api/v1/support-tickets/unread'),
    enabled: !!user, refetchInterval: 10000, staleTime: 5000,
  })
}
